/**
 * @type {string}
 */
const SCREEN_TYPE_MOBILE = 'mobile';

/**
 * @type {string}
 */
const SCREEN_TYPE_DESKTOP = 'desktop';


export class ScreenDetectorListener {
    /**
     * @param {ScreenDetector} screenDetector
     */
    constructor(screenDetector) {
        this.screenDetector = screenDetector;
        this.mobileViewListeners = [];
        this.desktopViewListeners = [];
        this.mobileToDesktopChangeListeners = [];
        this.desktopToMobileChangeListeners = [];

        this._previousScreenType = null;
        this._registerWindowResizeListener();
    }

    /**
     * @param {function} callback
     */
    onMobileView(callback) {
        this.mobileViewListeners.push(callback);
    }

    /**
     * @param {function} callback
     */
    onDesktopView(callback) {
        this.desktopViewListeners.push(callback);
    }

    /**
     * @param {function} callback
     */
    onMobileToDesktopChange(callback) {
        this.mobileToDesktopChangeListeners.push(callback);
    }

    /**
     * @param {function} callback
     */
    onDesktopToMobileChange(callback) {
        this.desktopToMobileChangeListeners.push(callback);
    }

    /**
     * @param {array|function[]} callbacks
     * @returns {ScreenDetectorListener}
     * @private
     */
    _executeCallbacks(callbacks) {
        for (let callback of callbacks) {
            callback();
        }

        return this;
    }

    _registerWindowResizeListener() {
        window.addEventListener("resize", () => {
            const isMobile = this.screenDetector.isMobileView();

            let callbacks = isMobile
                ? this.mobileViewListeners
                : this.desktopViewListeners
            ;

            if (isMobile && this._previousScreenType === SCREEN_TYPE_DESKTOP) {
                callbacks = [...callbacks, ...this.desktopToMobileChangeListeners];
            }

            if (!isMobile && this._previousScreenType === SCREEN_TYPE_MOBILE ) {
                callbacks = [...callbacks, ...this.mobileToDesktopChangeListeners];
            }

            this._executeCallbacks(callbacks);

            this._previousScreenType = isMobile
                ? SCREEN_TYPE_MOBILE
                : SCREEN_TYPE_DESKTOP
            ;
        });
    }
}